import { Component, ComponentFactoryResolver, Input, OnInit, ViewChild } from '@angular/core';
import { DynamicItemInterface } from '../../___LOGIC/__interfaces/dynamic-item';
import { DynamicItemDirective } from '../../___LOGIC/__directives/dynamic-item.directive';
import { CrudFieldItemService } from 'src/app/___LOGIC/__crud/crud-field-item.service';

@Component({
  selector: 'app-dynamic-crud-field',
  templateUrl: './dynamic-crud-field.component.html',
  styleUrls: ['./dynamic-crud-field.component.css']
})
export class DynamicCrudFieldComponent implements OnInit {

  //REFACTOR
  @Input() crudId;

  // OLD
  // For dynamic component
  @Input() fieldsToRender: CrudFieldItemService[];
  @Input() fieldToRender: CrudFieldItemService;
  currentAdIndex = -1;
  @ViewChild(DynamicItemDirective, {static: true}) adHost: DynamicItemDirective;
  interval: any;
ng 
  // DYNAMIC COMPONENT
  // The component to dynamically add
  adItem: any;
  componentFactory: any;
  viewContainerRef: any;
  componentRef: any;

  //  ComponentFactoryResolver ->
  constructor(private componentFactoryResolver: ComponentFactoryResolver) {
    if (this.fieldsToRender && this.fieldsToRender.length > 1) {
      this.loadComponent();
    }
   }

  ngOnInit(): void {
    if (this.fieldsToRender && this.fieldsToRender.length > 1) {
      this.loadComponent();
    }
    // this.getAds();
  }

  // For dynamic component
  ngOnDestroy() {
    clearInterval(this.interval);
  }

  // For dynamic component
  loadComponent() {
    // IN CASE AN ARRAY IS PASSED
    if (this.fieldsToRender && this.fieldsToRender.length > 1) {
      this.renderFormFields();
    } else {
      debugger;
      // IN CASE A SINGLE FIELD IS PASSED - TO DO : make like true part of if
      this.adItem = this.fieldsToRender;
      this.componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.adItem.component);
      this.viewContainerRef = this.adHost.viewContainerRef;
      //
      this.componentRef = this.viewContainerRef.createComponent(this.componentFactory);
      (<DynamicItemInterface> this.componentRef.instance).data = this.adItem.data;
    }
  }

  renderFormFields() {
    for (let field of this.fieldsToRender) {
      this.currentAdIndex = (this.currentAdIndex + 1) % this.fieldsToRender.length;
      this.adItem = this.fieldsToRender[this.currentAdIndex];
      // New code May 22
      this.adItem.data.crudId = this.crudId;
      //
      this.componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.adItem.component);
      this.viewContainerRef = this.adHost.viewContainerRef;
      //
      this.componentRef = this.viewContainerRef.createComponent(this.componentFactory);
      (<DynamicItemInterface> this.componentRef.instance).data = this.adItem.data;
      /* console.log(this.adItem.data); */
    }
  }

  // For dynamic component
  getAds() {
    this.interval = setInterval(() => {
      this.loadComponent();
    }, 3000);
  }


}
